module.exports = __webpack_public_path__ + "img/return-icon.6c4dff3d.svg";